import React, { useMemo, useEffect } from 'react';
import { DropdownTemplate, WithLoadingComponent, SkeletonLoader } from "components/shared"
import { FlexSectionContainer } from "components/layout/";
import { ReportingService } from "services/http";
import { useHistory } from 'react-router';
import Utils from "utils";

export const DimensionsFilter = (props) => {

    const { sources, wilayas, regions } = props.data;
    const history = useHistory();
    const users = props.data.users.map(item => { let user = {}; user['username'] = item; return user; });
    const currentSearchParam = JSON.parse(new URLSearchParams(history.location.search).get("filter"));
    const datesParam = currentSearchParam ? { startDate: currentSearchParam["startDate"], endDate: currentSearchParam["endDate"] } : null;
    const [filter, setFilter] = React.useState(currentSearchParam);

    useEffect(() => {
        if (filter && Object.values(filter).some(item => item)) {
            Object.keys(filter).forEach(key => {
                if (filter[key] === null) {
                    delete filter[key];
                }
            })
            Utils.pushURLSearchParams(history, "filter", JSON.stringify({ ...filter, ...datesParam }));
        }
    }, [filter]);

    const dropdownSelectedValue = (value) => {
        return currentSearchParam ? value : null;
    }

    useEffect(() => {
        !currentSearchParam && setFilter({});
    }, [currentSearchParam])


    return (
        <FlexSectionContainer title="Filters">
            <DropdownTemplate
                placeholder="Select a source"
                options={sources}
                selectedItem={dropdownSelectedValue(filter?.canal)}
                optionLabel={"sourceId"}
                optionValue={"sourceId"}
                className="sm-dropdown mr-3"
                scrollHeight={200}
                onItemChange={(e) => {
                    setFilter({ ...filter, canal: e.value });
                }}
            />
            <DropdownTemplate
                placeholder="Select an agent"
                options={users}
                selectedItem={dropdownSelectedValue(filter?.agent)}
                optionLabel="username"
                optionValue="username"
                className="sm-dropdown mr-3"
                scrollHeight={200}
                onItemChange={(e) => {
                    setFilter({ ...filter, agent: e.value });
                }} />
            <DropdownTemplate
                placeholder="Select a wilaya"
                options={wilayas}
                selectedItem={dropdownSelectedValue(filter?.wilaya)}
                optionLabel="wilayaName"
                optionValue="wilayaId"
                className="sm-dropdown mr-3"
                scrollHeight={200}
                onItemChange={(e) => {
                    setFilter({ ...filter, wilaya: e.value });
                }} />
            <DropdownTemplate
                placeholder="Select a region"
                options={regions}
                selectedItem={dropdownSelectedValue(filter?.region)}
                optionLabel="regionId"
                optionValue="regionId"
                className="sm-dropdown"
                scrollHeight={200}
                onItemChange={(e) => {
                    setFilter({ ...filter, region: e.value });
                }} />
        </FlexSectionContainer>
    );
}

export const FlexLoader = () => {
    return <div className="d-flex">
        {[...Array(4)].map(() => <SkeletonLoader rectangle factor={1} />)}
    </div>
}

export const DimensionsFilterHoc = () => {
    const DimensHoc = useMemo(() => WithLoadingComponent(DimensionsFilter, () => ReportingService.getFilterPrerequistes(), <FlexLoader />)(), []);
    return <DimensHoc />
}